type Dimensions = {
  fit: string;
  frameHeight: number;
  frameWidth: number;
  imageHeight: number;
  imageWidth: number;
};

export type InertAxes = { x: boolean, y: boolean };

// Position (object-position / background-position %) only moves an axis where the rendered
// image and its frame differ in size, so the sliders for other axes are inert.
const inertPositionAxes = ({ fit, frameHeight, frameWidth, imageHeight, imageWidth }: Dimensions): InertAxes => {
  if (!imageWidth || !imageHeight || !frameWidth || !frameHeight) return { x: false, y: false };
  if (fit === 'fill') return { x: true, y: true };

  const imageRatio = imageWidth / imageHeight;
  const frameRatio = frameWidth / frameHeight;

  if (Math.abs(imageRatio - frameRatio) < 0.01) return { x: true, y: true };

  // contain letterboxes the axis the image doesn't fill; cover overflows the one it does
  const xActive = fit === 'cover' ? imageRatio > frameRatio : imageRatio < frameRatio;

  return { x: !xActive, y: xActive };
};

export default inertPositionAxes;
